import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-sand/70 border-t border-line/60 text-ink mt-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo size={44} />
            <p className="mt-6 max-w-md text-ink2 text-[15px] leading-relaxed">
              A pharmaceutical-grade medicinal cannabis cultivation and processing platform — built in Uganda for regulated international markets.
            </p>
            <div className="mt-8 flex flex-col gap-2 text-sm text-ink2">
              <span className="inline-flex items-center gap-2"><MapPin size={14} className="text-copper" /> Kampala, Uganda</span>
              <a href="mailto:brett.rierson@maishapharma.com" className="inline-flex items-center gap-2 hover:text-forest transition-colors" data-testid="footer-email">
                <Mail size={14} className="text-copper" /> brett.rierson@maishapharma.com
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline">Site</div>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["/", "Home"],
                ["/about", "About"],
                ["/our-model", "Our Model"],
                ["/team", "Team & Advisors"],
                ["/umcc", "Policy & UMCC"],
                ["/investors", "Investors & Partners"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-ink2 hover:text-forest transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/[\s&]+/g, "-")}`}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline">Inquiries</div>
            <p className="mt-5 text-sm text-ink2 max-w-sm">
              For investor relations, partnership opportunities, or pharmaceutical importer inquiries.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta-contact"
              className="mt-6 inline-flex items-center gap-2 border-b border-forest pb-1 text-sm text-forest hover:text-forest/75 transition-colors"
            >
              Open inquiry form <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-line/60 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-ink2/80">
          <span>© {new Date().getFullYear()} Maisha Pharma. All rights reserved.</span>
          <span className="font-mono tracking-wider">Regulated medicinal cannabis · Export-led · East Africa</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
